const openMapLocation = () => {
  const mapUrl = "https://maps.app.goo.gl/yxSQDTYSxmBMGjP38";

  window.open(mapUrl, "_blank", "noopener,noreferrer");
};

export default openMapLocation;
